import type { HomologationItemMessages } from '@/entities/Document';

export const DOCUMENT_NOT_PENDING_VERIFICATION_MESSAGE =
  'Esta revisão não está mais pendente de verificação.';
export const RECORD_NOT_PENDING_VERIFICATION_MESSAGE =
  'Este registro não está mais pendente de verificação.';
export const VERIFICATION_ITEM_LOAD_ERROR_MESSAGE = 'Não foi possível carregar o documento.';
export const FALLBACK_USER_NAME = (userId: number) => `Usuário ID: ${userId}`;
export const FALLBACK_POSITION = 'Cargo não encontrado';

export const VERIFICATION_ITEM_MESSAGES: HomologationItemMessages = {
  documentNotPending: DOCUMENT_NOT_PENDING_VERIFICATION_MESSAGE,
  recordNotPending: RECORD_NOT_PENDING_VERIFICATION_MESSAGE,
  loadError: VERIFICATION_ITEM_LOAD_ERROR_MESSAGE,
};
